import { useCallback, useState } from "react";
import {
    AgentSkillsView,
    AgentSkillsViewSchema,
} from "@common/types/views/agentSkillsView";
import { View } from "@common/types/views/views";
import {
    WORKSPACE_USER_CACHE_KEYS,
    useWorkspaceUserCache,
} from "@hooks/useWorkspaceUserCache";
import { mergeCachedView } from "@lib/mergeCachedView";
import { defaultAgentSkillsView } from "./agentSkillsView";
import { agentSkillsViewConfig } from "./agentSkillsViewConfig";

export function useAgentSkillsView() {
    const [cachedView, setCachedView] = useWorkspaceUserCache<AgentSkillsView>(
        WORKSPACE_USER_CACHE_KEYS.AGENT_SKILLS_PAGE_VIEW_CACHE_KEY,
        AgentSkillsViewSchema,
    );
    const [view, setView] = useState<AgentSkillsView>(() =>
        mergeCachedView(
            cachedView,
            defaultAgentSkillsView,
            agentSkillsViewConfig,
        ),
    );

    const handleViewChange = useCallback(
        (newView: View) => {
            const parsed = AgentSkillsViewSchema.safeParse(newView);
            if (!parsed.success) {
                return;
            }
            setView(parsed.data);
            setCachedView(parsed.data);
        },
        [setCachedView],
    );

    return { view, handleViewChange };
}
